import React from "react";
import FinanceStatistiques from "./FinanceStatistiques";
import BiensStatistiques from "./BiensStatistiques";
export default function TypesOfStatistique({
  typePeriodeFilter,
  isBienOrFinance,
}) {
  return (
    <section>
      {isBienOrFinance === "biens" && (
        <BiensStatistiques typePeriodeFilter={typePeriodeFilter} />
      )}
      {isBienOrFinance === "finances" && (
        <FinanceStatistiques typePeriodeFilter={typePeriodeFilter} />
      )}
    </section>
  );
}
